import React from 'react';
import { useCalendar } from '../calendarContext';
import MonthView from './monthView';
import { useIsMobile } from '../../../../../../platform/util/utils'; // or your own path

const PrintableView = React.forwardRef((props, ref) => {
  const { currentMonth } = useCalendar();
  const isMobile = useIsMobile();

  return (
    <div ref={ref} className="print-calendar-body" style={{ position: 'relative' }}>
      {MonthView && (
        <>
          {/* ✅ Vertical Left-Side Copyright */}
          <div
            style={{
              position: 'absolute',
              left: 0,
              top: '50%',
              transform: 'rotate(-90deg) translate(-50%, -100%)',
              transformOrigin: 'left top',
              fontSize: '0.55rem',
              color: '#666',
              whiteSpace: 'nowrap',
              zIndex: 10,
            }}
          >
            © {new Date().getFullYear()} Timely365.com
          </div>

          {/* ✅ Main Month View */}
        <MonthView
          monthDate={currentMonth}
            showEventDetailsInside={!isMobile}
            showEventDetailsOutside={isMobile}
          calculateHeight={true}
          {...props}
        />
        </>
      )}
    </div>
  );
});

export default PrintableView;
